var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-list",
        { staticClass: "pa-0 mx-0", attrs: { dense: "" } },
        [
          _vm.filterToggle == _vm.filterToggles.selected &&
          _vm.selectionCount == 0
            ? _c(
                "div",
                { staticClass: "pa-4 text-xs-center" },
                [
                  _c("v-icon", { attrs: { color: "warning" } }, [
                    _vm._v("warning"),
                  ]),
                  _c("br"),
                  _vm._v(
                    "\n      No " + _vm._s(_vm.entityName) + " selected\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "VirtualList",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(
                    _vm.filterToggle == _vm.filterToggles.selected &&
                    _vm.selectionCount == 0
                  ),
                  expression:
                    "!(filterToggle == filterToggles.selected && selectionCount == 0)",
                },
              ],
              ref: "virtualScroll",
              attrs: { size: 40, remain: 6 },
            },
            [
              _vm._l(_vm.combinedItems, function (item, index) {
                return [
                  item.type === 0 && _vm.hasCategory
                    ? [
                        _c(
                          "v-list-tile",
                          {
                            key: `category-${index}`,
                            on: {
                              click: function ($event) {
                                return _vm.toggleExpand(item)
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              { staticStyle: { "min-width": "0px" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    color: "primary",
                                    "input-value": _vm.isSelected(item),
                                    "hide-details": "",
                                    indeterminate: _vm.isPartialSelection(item),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleCategory(item)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.hideCategoryIcons
                              ? _c(
                                  "v-list-tile-avatar",
                                  {
                                    staticClass: "pl-0",
                                    staticStyle: { "min-width": "0px" },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          item.icon || _vm.getIcon(item.name)
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-list-tile-content", {
                              staticStyle: { "flex-grow": "1" },
                              domProps: { textContent: _vm._s(item.name) },
                            }),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              {
                                staticClass:
                                  "font-weight-light grey--text text--darken-0",
                                staticStyle: { "flex-grow": "0" },
                              },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "rgba(0,0,0,.07)",
                                      small: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          "error--text": item.count == 0,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.count) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-action",
                              {
                                staticClass: "ml-2",
                                staticStyle: { "min-width": "0" },
                              },
                              [
                                _c("v-icon", [
                                  _vm._v(
                                    _vm._s(
                                      item.open || _vm.isSearching
                                        ? "arrow_drop_up"
                                        : "arrow_drop_down"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : item.type !== 0
                    ? [
                        _c(
                          "v-list-tile",
                          {
                            key: `item-${index}`,
                            on: {
                              click: function ($event) {
                                return _vm.toggleStation(item.id)
                              },
                            },
                          },
                          [
                            !_vm.hideCategoryIcons
                              ? _c("v-list-tile-avatar", {
                                  staticStyle: { "min-width": "0px" },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-action",
                              { staticStyle: { "min-width": "0px" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    primary: "",
                                    color: "primary",
                                    "input-value": _vm.getStationValue(item),
                                    "hide-details": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c(
                                  "v-list-tile-title",
                                  { staticClass: "font-weight-thin" },
                                  [
                                    _vm._v(
                                      _vm._s(item[_vm.entityNameKey]) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-sub-title", {
                                  domProps: {
                                    innerHTML: _vm._s(item.description),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }